<section id="about" class="about-section py-24 relative overflow-hidden">
  <div class="about-bg"></div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <div class="text-center mb-14">
      <span class="section-badge">Who We Are</span>
      <h2 class="text-4xl sm:text-5xl font-bold mt-4 mb-4">
        Built on <span class="gradient-text">Passion</span>,<br />Powered by Code
      </h2>
      <p class="text-slate-600 max-w-2xl mx-auto text-lg">
        Trieon Technologies is a software company focused on building reliable digital products —
        for clients and as company initiatives that solve real operational problems.
      </p>
      <div class="section-underline"></div>
    </div>

    <article class="company-profile">
      <p class="company-kicker">About the company</p>
      <h3 class="company-name">Trieon Technologies</h3>
      <p class="company-tagline">Software company · Philippines</p>

      <p class="company-bio">
        We design, build, and ship software systems that businesses can run on — from custom
        platforms and SaaS products to cross-platform mobile apps.
      </p>
      <p class="company-bio">
        Our work spans client delivery and company-built products including GoCareMo, TrieonHR,
        and TrieonFlow, with end-to-end ownership across web, mobile, APIs, and cloud.
      </p>

      <ul class="company-highlights">
        @for (item of focusAreas; track item) {
          <li>{{ item }}</li>
        }
      </ul>

      <div class="company-contact">
        <a class="company-mail" href="mailto:business@trieon.tech">
          <i class="pi pi-envelope"></i>
          business@trieon.tech
        </a>
        <p class="company-address">
          <i class="pi pi-map-marker"></i>
          <span>San Antonio Ave., Brgy. San Antonio, Parañaque City, Philippines</span>
        </p>
      </div>

      <div class="company-links">
        <button type="button" class="company-link" (click)="scrollTo('#projects')">
          <i class="pi pi-th-large"></i>
          View our work
        </button>
        <button type="button" class="company-link" (click)="scrollTo('#contact')">
          <i class="pi pi-send"></i>
          Contact us
        </button>
      </div>
    </article>

    <div class="values-block">
      <h3 class="values-title">What drives us</h3>
      <div class="values-grid">
        @for (val of values; track val.title) {
          <div class="value-card">
            <div class="value-icon">
              <i class="pi" [class]="val.icon"></i>
            </div>
            <h4>{{ val.title }}</h4>
            <p>{{ val.description }}</p>
          </div>
        }
      </div>
    </div>
  </div>
</section>
